var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { apiDeleteSlideSelectAll } from '../../../../actions/ProffitSearchSelectAction';
import { apiCreateProffitSearchShare, apiGetListProffitSearchShareMembers, } from '../../../../actions/ProffitSearchShareAction';
import { notify, wrapDispatch, wrapNotifyError } from '../../../action';
/**
 * スライド共有を制御するuse
 * @param dispatch
 * @returns {{onSubmitShare: ((function(*): Promise<void>)|*)}}
 */
export const useSlideSearchCommonShare = (dispatch) => {
    /**
     * オートコンプリートの非同期検索
     * @type {*}
     */
    const onLoadShareMemberOptions = useCallback((keyword) => __awaiter(void 0, void 0, void 0, function* () {
        const { payload } = yield wrapDispatch(dispatch, apiGetListProffitSearchShareMembers({ keyword }));
        const { list = [] } = payload;
        return list.map((v) => (Object.assign(Object.assign({}, v), { label: v.email, value: v.email })));
    }), [dispatch]);
    /**
     * 共有フォームをsubmitした時のイベント
     * @type {(function(*): Promise<void>)|*}
     */
    const onSubmitShare = useCallback((values) => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            // shareのAPI実行
            yield wrapDispatch(dispatch, apiCreateProffitSearchShare(Object.assign(Object.assign({}, values), { shareEmail: values.shareEmail.map((v) => v.email) })));
            // 選択状態を全削除
            yield wrapDispatch(dispatch, apiDeleteSlideSelectAll());
            notify('共有しました');
        }));
    }), [dispatch]);
    /**
     * 共有フォームのキーワード入力時の文言調整
     * @type {function(*): string}
     */
    const noShareMemberOptionsMessage = useCallback((args) => {
        const { inputValue: keyword } = args;
        return keyword
            ? `「${keyword}」に該当する共有履歴はありません`
            : 'メールアドレスを入力してください';
    }, []);
    return {
        noShareMemberOptionsMessage,
        onLoadShareMemberOptions,
        onSubmitShare,
    };
};
export default useSlideSearchCommonShare;
